import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ClubModule } from '@modules/application/application';
import { ApiService } from '@modules/shared/services/api.service';
import { catchError, map } from 'rxjs/operators';
import { getPeruTime } from '@modules/shared/pipes/ro-date';

@Injectable({
    providedIn: 'root',
})
export class ModuleService extends ApiService {
    modules$ = new BehaviorSubject<ClubModule[]>([]);

    constructor(protected injector: Injector) {
        super(injector);
        this.getModules();
    }

    getModules(): Observable<ClubModule[]> {
        return this.get<ClubModule[]>('modules').pipe(
            catchError(() => of([])),
            map((modules) => {
                this.modules$.next(modules);
                return modules;
            })
        );
    }

    moduleIsInactive(module: ClubModule) {
        const { inactive_start_minutes, inactive_end_minutes } = module;
        const now = getPeruTime();
        const startOfDay = now.startOf('day');
        const inactiveStart = startOfDay.add(inactive_start_minutes, 'minutes');
        const inactiveEnd = startOfDay.add(inactive_end_minutes, 'minutes');
        return now.isBetween(inactiveStart, inactiveEnd);
    }

    isModuleAvailable(identifier: string): Observable<boolean> {
        return this.modules$.pipe(
            map((modules) => {
                const currentModule = modules.find((m) => m.identifier === identifier);
                if (!currentModule) {
                    return false;
                }

                if (currentModule.inactive_start_minutes === 0 && currentModule.inactive_end_minutes === 0) {
                    return true;
                }

                return !this.moduleIsInactive(currentModule);
            })
        );
    }
}
